import React, { useState } from 'react';
import moment from 'moment';
import { FiFileText } from 'react-icons/fi';
import ShieldCheckIcon from '../../ShieldCheckIcon';
import { toast } from '../../Toast';
import { ContactListSummary } from '../../../../model/List';
import { ContactRow, contactsCsv } from './contactsData';
import ContactsModal from './ContactsModal';

type Scope = 'view' | 'subscribed' | 'selected';

// Export Contacts (spec 219:9110). Builds the file in the browser from the contacts already loaded — always CSV
// (the app has no xlsx writer); registry and engagement columns have no source yet.
const ExportContactsModal: React.FC<{ view: string; shown: ContactRow[]; selected: ContactRow[]; lists: ContactListSummary[]; onClose: () => void }> = ({ view, shown, selected, lists, onClose }) => {
    const [scope, setScope] = useState<Scope>(selected.length ? 'selected' : 'view');
    const [withTags, setWithTags] = useState(true);
    const subscribed = shown.filter(c => c.subscribed);
    const rows = scope === 'view' ? shown : scope === 'subscribed' ? subscribed : selected;

    const download = () => {
        const blob = new Blob([contactsCsv(rows, lists, withTags)], { type: 'text/csv;charset=utf-8' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `contacts-${moment().format('YYYY-MM-DD')}.csv`;
        a.click();
        URL.revokeObjectURL(a.href);
        toast.success(`Downloaded ${rows.length.toLocaleString()} contacts`);
        onClose();
    };

    const option = (value: Scope, title: string, sub: string, disabled = false) =>
        <button type="button" role="radio" aria-checked={scope === value} disabled={disabled} className={`contacts-option${scope === value ? ' on' : ''}`} onClick={() => setScope(value)}>
            <span className="radio" /><span><strong>{title}</strong><small>{sub}</small></span>
        </button>;

    return <ContactsModal icon={<FiFileText />} title="Export Contacts" sub={`${shown.length.toLocaleString()} contacts · list: ${view}`} note="The file downloads to this computer" onClose={onClose}
        buttons={<button type="button" className="btn-primary" disabled={!rows.length} onClick={download}><FiFileText /> Export {rows.length.toLocaleString()} Contacts</button>}>
        <div className="contacts-rules-label">Which contacts</div>
        <div className="contacts-options" role="radiogroup" aria-label="Which contacts">
            {option('view', `Everyone in this view (${shown.length.toLocaleString()})`, `${view}, including unsubscribed`)}
            {option('subscribed', `Subscribed only (${subscribed.length.toLocaleString()})`, 'Safe to import into another email tool')}
            {option('selected', `Selected contacts (${selected.length})`, selected.length ? 'The ones ticked in the list' : 'Tick contacts in the list first', !selected.length)}
        </div>
        <div className="contacts-rules-label">Columns</div>
        <label className="contacts-tick"><input type="checkbox" checked disabled /> Name, email, status and lists</label>
        <label className="contacts-tick"><input type="checkbox" checked={withTags} onChange={e => setWithTags(e.target.checked)} /> Tags and how they agreed</label>
        <label className="contacts-tick off"><input type="checkbox" disabled /> Registry match (holder number, shares) — not connected yet</label>
        <label className="contacts-tick off"><input type="checkbox" disabled /> Engagement (opens, clicks, last active) — not connected yet</label>
        <div className="contacts-warn"><ShieldCheckIcon /> Contact details are personal information. Keep the file somewhere safe and delete it when you’re done.</div>
    </ContactsModal>;
};

export default ExportContactsModal;
